<template>
  <div class="menuBody" style="margin-left:25px;">
    <div class="menuTool">
      <el-card class="box-card">
        <el-row :gutter="1">
          <div style="float:left;margin-left:30px;">
            <el-button type="primary" size="small" plain style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'sys:web:dict:manage:add'" @click="RoleAdd()">字典添加</el-button>
          </div>
          <div style="float:left;margin-left:30px;">
             <el-select  clearable v-model="TypeListvalue" placeholder="请选择" size="small"  @change="TypeListOne()">
              <el-option
                v-for="item in TypeList"
                :key="item.value"
                :label="item.label"
                :value="item.label">
              </el-option>
            </el-select>
          </div>
          <div style="float:left;">
            <el-input placeholder="请输入描述" v-model="describe" style="width:130px;margin-left:30px;margin-right:30px" size="small"></el-input>
          </div>
          <div style="float:left;">
              <el-button type="primary" size="small" plain   v-Jurisdiction="'sys:web:dict:manage:getList'"  @click="Inquire()">查询</el-button>
          </div>
          <el-table tooltip-effect="light"  v-loading="loading" :data="tableData" style="width: 100%;height:500px;margin-bottom: 20px;margin-top:20px" row-key="id" border  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column show-overflow-tooltip prop="value" label="键值"></el-table-column>
    <el-table-column show-overflow-tooltip prop="label" label="标签" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="type" label="类型" ></el-table-column>
      <el-table-column show-overflow-tooltip prop="description" label="描述" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="sort" label="排序" ></el-table-column>
    <el-table-column fixed="right" label="操作">
     <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small"
          v-Jurisdiction="'sys:web:dict:manage:edit'"
                     title="修改"></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small"
          v-Jurisdiction="'sys:web:dict:manage:del'"
                     title="删除"  v-debounce></el-button>
        </template>
    </el-table-column>
  </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
    <CommonDialog :param="diaLogData" @Visible="Visible" ref="CommonDialog"/>
  </div>
</template>
<script>
import CommonDialog from "../common/CommonDialog";
export default {
  name: "dictionaries",
  components: {CommonDialog},
  data() {
    return {
      loading:false,
         total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
      describe:"",
      tableData: [],
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      TypeList:[],
      TypeListvalue:"",
    }
  },
  methods: {
    TypeListOne(){},
    // DeDICTGET_TYPE
    DictgetType(){
      // DICTGET_TYPE
       this.$http.get(this.$requestUrl.DICTGET_TYPE).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          let records = result.data.records
          let arr = []
          for(let val of records){
            let obj = {
              "value":val.id,
              "label":val.type
            }
            arr.push(obj)
          }
          this.TypeList = arr
        } else {
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    handleSizeChange(val) {
        this.pagesize  = val
        this.getAllMenu()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.getAllMenu()
    },
    getAllMenu() {
      let PageSize ={
         "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
      }
      this.$http.post(this.$requestUrl.POST_DICT_LIST,PageSize).then((res) => {
        let result = res.data;
         
        if (200 === result.code) {
          this.total = result.data.total
          this.tableData = result.data.records;
          this.loading=false
        } else {
          this.$message.error(result.msg)
          this.loading = false
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
        this.loading = false
      })
    },
    RoleAdd(){
        // 字典添加
        this.$refs.CommonDialog.title = "添加";
        this.$refs.CommonDialog.dialogVisible = true;
        let rowone ={}
        this.$refs.CommonDialog.formLabelAlign= rowone;
    },
    editMenu(row) { // 修改
         this.$refs.CommonDialog.title = "修改";
         this.$refs.CommonDialog.dialogVisible = true;
         this.$refs.CommonDialog.formLabelAlign= row;
    },
    delMenu(row) { // 删除
      this.$confirm('您确认要删除当前字典, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
     this.$http.delete(this.$requestUrl.DELETE_DICT+row.id).then((res) => {
       let result = res.data;
        if (200 === result.code) {
           this.getAllMenu()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
        } else {
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    Inquire(){
      // 查询
      let PageSize ={
         "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "description":this.describe,
        "type":this.TypeListvalue,
      }
      this.$http.post(this.$requestUrl.POST_DICT_LIST,PageSize).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.tableData = result.data.records;
        } else {
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    Visible(data){
      if(data == false){
        this.getAllMenu();
      }
    }
  },
  mounted() {
    this.getAllMenu();
    this.DictgetType()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>